"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _flagSizeMap = require("./assets/flagSizeMap");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const getFlagData = isoCode => _flagSizeMap.sizeMap.filter(flag => flag.isoCode === isoCode)[0];

const Flag = _styledComponents.default.div.withConfig({
  displayName: "Flag"
})(["width:", "px;height:", "px;background-image:url(./assets/flags.png);background-repeat:no-repeat;background-position:", "px 0px;display:inline-block;margin-right:0.75rem;border:1px solid ", ";@media only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){background-image:url(./assets/flags@2x.png);background-size:5630px 15px;}"], props => getFlagData(props.isoCode).width, props => getFlagData(props.isoCode).height, props => getFlagData(props.isoCode).xPos, props => props.theme.palette.border);

Flag.propTypes = {
  isoCode: _propTypes.default.string
};
Flag.defaultProps = {
  isoCode: 'us'
};
var _default = Flag;
exports.default = _default;